﻿import React from 'react';

// components 
import PossessionsTableHeaderMobile from './PossessionsTableHeaderMobile';
import PossessionsTableContentMobile from './PossessionsTableContentMobile';
import PossessionsTableContentChartMobile from './PossessionsTableContentChartMobile';


const PossessionsTableMobile = ({
    content,
    selected,
    heading,
    isExpanded,
    setIsExpanded
}) => {

    const parent = React.useRef();

    return (
        <div className="possessions__table__mobile" ref={parent}>
            <PossessionsTableHeaderMobile
                parent={parent}
                content={content}
                selected={selected}
                heading={heading}
            />

         {content.insuranceCoverage.map(({ title, description, levels }, index) => (
             <React.Fragment>

                {levels.length > 0 &&
                     <PossessionsTableContentChartMobile
                         levels={levels}
                         description={description}
                         title={title}
                         index={index}
                         isExpanded={isExpanded}
                         setIsExpanded={setIsExpanded}
                     />
                 }

                 {levels.length <= 0 &&
                     <PossessionsTableContentMobile
                         content={content}
                         levels={levels}
                         description={description}
                         title={title}
                         index={index}
                         isExpanded={isExpanded}
                         setIsExpanded={setIsExpanded}
                     />
                 }

             </React.Fragment>
         ))}
        </div>
     )
};

export default PossessionsTableMobile;

